import { SelectOption } from "../../../../logic/types";
import { FieldData } from '../../types'

export type ChipsWithSelectData =
  FieldData &
  {
    options?: Array<SelectOption | string>
    draggable: boolean
    availableTabs?: Array<ChipsInputTabs>
    formatter?: (value: string) => string
  }

export enum ChipsInputTabs {
  Chips,
  Text,
  Sort
}
